/* eslint-disable react/function-component-definition */
import { COUNTRY_CODES } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/country';
import TickIcon from '../../../../assets/icons/TickIcon';
import CustomSelect from '../CustomSelect';
import styles from './CountrySelect.module.css';

type CountrySelectProps = {
  value: string;
  setValue: (value: string) => void;
  label?: string;
  placeholder?: string;
  wrapperClassName?: string;
};

const CountrySelect = ({
  value,
  setValue,
  label = 'Country',
  placeholder = 'Select Country',
  wrapperClassName = '',
}: CountrySelectProps) => {
  const currentSelectedCountry = COUNTRY_CODES.find((opt) => opt.name === value);

  return (
    <div className={wrapperClassName}>
      <div className={styles.countrySelectLabel}>{label} *</div>
      <CustomSelect
        selectLabel={
          <div className={`${styles.countrySelectLabelText} ${currentSelectedCountry ? styles.active : ''}`}>
            {currentSelectedCountry?.name || placeholder}
          </div>
        }
        style={{
          padding: '8px 10px',
          width: '100%',
        }}
        dropDownElement={(setOpened) => (
          <div className={styles.countryDropdown}>
            {COUNTRY_CODES.map((option) => (
              <button
                type="button"
                key={option.code}
                className={`${option.name === value ? styles.active : ''} ${styles.countryDropdownItem}`}
                onClick={() => {
                  setValue(option.name);
                  setOpened(false);
                }}
              >
                {option.name}
                {option.name === value && <TickIcon color="var(--icon-highlight)" width={20} height={20} />}
              </button>
            ))}
          </div>
        )}
      />
    </div>
  );
};

export default CountrySelect;
